import { render, staticRenderFns } from "./ConfirmPopupSeted.vue?vue&type=template&id=1f1c7256&scoped=true"
import script from "./ConfirmPopupSeted.vue?vue&type=script&lang=js"
export * from "./ConfirmPopupSeted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c7256",
  null
  
)

export default component.exports